import { render, staticRenderFns } from "./goodsListModal.vue?vue&type=template&id=3667c578&scoped=true&"
import script from "./goodsListModal.vue?vue&type=script&lang=js&"
export * from "./goodsListModal.vue?vue&type=script&lang=js&"
import style0 from "./goodsListModal.vue?vue&type=style&index=0&id=3667c578&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667c578",
  null
  
)

export default component.exports